const features = [
  {
    icon: "ri-grid-line",
    color: "from-blue-500 to-indigo-500",
    title: "网格台账管理",
    desc: "精细化管理辖区内人、地、物、事、组织五类基础数据，形成动态更新的网格台账，支持随时查询与权限管控。",
    tags: ["人口档案", "房屋台账", "组织信息"],
  },
  {
    icon: "ri-dashboard-3-line",
    color: "from-amber-500 to-orange-400",
    title: "民生看板",
    desc: "汇聚居民诉求、民政救助、社区服务等数据，以可视化看板呈现辖区民生状况，辅助基层干部精准施策、回应民意。",
    tags: ["民情汇聚", "可视看板", "诉求追踪"],
  },
  {
    icon: "ri-map-pin-2-line",
    color: "from-teal-500 to-cyan-400",
    title: "设施分布管理",
    desc: "对辖区内公共设施、市政基础设施、便民服务点进行空间标注与档案维护，支持巡检计划制定与设施状态跟踪。",
    tags: ["设施标注", "巡检计划", "档案维护"],
  },
  {
    icon: "ri-alert-line",
    color: "from-rose-500 to-red-400",
    title: "隐患标注上报",
    desc: "网格员通过移动端一键标注安全隐患位置与等级，系统自动预警并关联整改责任人，实现隐患从发现到消除的全程追踪。",
    tags: ["移动上报", "等级预警", "整改追踪"],
  },
  {
    icon: "ri-loop-left-line",
    color: "from-emerald-500 to-green-400",
    title: "事件闭环处置",
    desc: "事件从上报、接单、处置到核查、归档全流程数字化管理，每个节点均有时效要求与责任绑定，确保事事有回应、件件有落实。",
    tags: ["全程追踪", "时效管控", "闭环归档"],
  },
  {
    icon: "ri-shield-check-line",
    color: "from-violet-500 to-purple-400",
    title: "综合治理支撑",
    desc: "与综治、公安、城管等平台对接，统一数据底座支撑跨部门协同处置，为街道办、派出所、管委会提供一体化数字治理工具。",
    tags: ["跨部门协同", "数据共享", "统一底座"],
  },
];

export default function GGFeatures() {
  return (
    <section className="py-20 px-8" style={{ background: "#f5f4fb" }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-xs font-semibold text-indigo-600 tracking-widest uppercase mb-2 block">Platform Features</span>
          <h2 className="text-3xl font-bold text-slate-800 mb-3">五大核心功能模块</h2>
          <p className="text-slate-500 text-sm max-w-lg mx-auto">网格台账、民生看板、设施分布、隐患标注到事件闭环，覆盖基层治理全链路</p>
        </div>
        <div className="grid grid-cols-3 gap-6">
          {features.map((f) => (
            <div key={f.title} className="bg-white rounded-2xl p-6 border border-slate-100 hover:border-indigo-200 transition-all cursor-pointer group">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center bg-gradient-to-br ${f.color} mb-4 group-hover:scale-105 transition-transform`}>
                <i className={`${f.icon} text-white text-xl`}></i>
              </div>
              <h3 className="text-slate-800 font-semibold text-base mb-2">{f.title}</h3>
              <p className="text-slate-500 text-sm leading-relaxed mb-4">{f.desc}</p>
              <div className="flex flex-wrap gap-1.5">
                {f.tags.map((t) => (
                  <span key={t} className="text-xs bg-indigo-50 border border-indigo-100 text-indigo-600 px-2 py-0.5 rounded-full">{t}</span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Customer banner */}
        <div className="mt-12 bg-gradient-to-r from-[#1a1030] to-[#1e2a50] rounded-2xl px-8 py-6 flex items-center justify-between">
          <div>
            <div className="text-amber-300 text-xs font-semibold tracking-widest uppercase mb-1">Target Organizations</div>
            <h3 className="text-white font-bold text-lg">服务基层政务核心机构</h3>
          </div>
          <div className="flex items-center gap-4">
            {[
              { icon: "ri-community-line", label: "街道办事处", sub: "网格台账·事件处置" },
              { icon: "ri-police-car-line", label: "基层派出所", sub: "隐患标注·综合治理" },
              { icon: "ri-government-line", label: "管委会", sub: "设施管理·民生看板" },
              { icon: "ri-group-line", label: "社区服务中心", sub: "民情收集·服务协同" },
            ].map((item) => (
              <div key={item.label} className="flex flex-col items-center text-center bg-white/10 rounded-xl px-4 py-3 border border-white/15 min-w-[110px]">
                <div className="w-8 h-8 flex items-center justify-center text-amber-300 mb-2">
                  <i className={`${item.icon} text-xl`}></i>
                </div>
                <div className="text-white font-semibold text-sm">{item.label}</div>
                <div className="text-white/50 text-xs mt-0.5">{item.sub}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
